/** Month abbreviations 1–12 */
const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const WEEKDAY_LABEL: Record<number, string> = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  0: 'Sun'
};
const WEEKDAY_SORT_ORDER: Record<number, number> = { 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5, 0: 6 };

export type WorkingRuleSummaryInput = {
  ruleType: string;
  payload: Record<string, unknown>;
};

function annualRange(payload: Record<string, unknown>): {
  startMonth: number;
  startDay: number;
  endMonth: number;
  endDay: number;
} {
  if (payload.startMonth != null && payload.startDay != null) {
    return {
      startMonth: Number(payload.startMonth) || 1,
      startDay: Number(payload.startDay) || 1,
      endMonth: Number(payload.endMonth) || Number(payload.startMonth) || 1,
      endDay: Number(payload.endDay) || Number(payload.startDay) || 1
    };
  }
  const m = Number(payload.month) || 1;
  const d = Number(payload.day) || 1;
  return { startMonth: m, startDay: d, endMonth: m, endDay: d };
}

function mdLabel(month: number, day: number): string {
  const mi = Math.min(12, Math.max(1, month)) - 1;
  return `${MONTH_SHORT[mi]!} ${day}`;
}

/** One-line summary for compact rule list rows. */
export function summarizeWorkingRule(rule: WorkingRuleSummaryInput): string {
  const k = rule.payload.kind as string | undefined;
  if (k === 'WEEKDAY_HOURS') {
    const weekdays = (rule.payload.weekdays as number[]) || [];
    const hours = Number(rule.payload.hours);
    const h = Number.isFinite(hours) ? hours : 0;
    const sorted = Array.from(new Set(weekdays)).sort(
      (a, b) => (WEEKDAY_SORT_ORDER[a] ?? 99) - (WEEKDAY_SORT_ORDER[b] ?? 99)
    );
    const labels = sorted.map((d) => WEEKDAY_LABEL[d] ?? String(d)).join(', ');
    return labels ? `${labels}, ${h} h` : `${h} h`;
  }
  if (k === 'ANNUAL_OFF') {
    const ar = annualRange(rule.payload);
    const a = mdLabel(ar.startMonth, ar.startDay);
    const b = mdLabel(ar.endMonth, ar.endDay);
    return a === b ? a : `${a} → ${b}`;
  }
  if (k === 'DATE_OFF') {
    const date = (rule.payload.date as string) || '';
    return date ? `${date}, off` : 'No date';
  }
  if (k === 'DATE_HOURS') {
    const date = (rule.payload.date as string) || '';
    const hours = Number(rule.payload.hours);
    const h = Number.isFinite(hours) ? hours : 0;
    return date ? `${date}, ${h} h` : `${h} h`;
  }
  return '';
}
